import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from './context/customContext';

import { useTranslation } from 'react-i18next';
import AuthenticationProvider from './config/AuthenticationProvider';
import './App.scss';
import { ToastContainer } from 'react-toastify';
import {
  initiateServiceInstance,
  initiateSmeInstance,
  initiateCertificationInstance,
  initiatePrintInstance,
  initiateOTPInstance,
  initiateStatisticsInstance,
  initiateOnboardingInstance,
  initiateAuthInstance,
  initiateOnboardingAuthInstance,
} from './config/axios';
import * as constants from './constants/common';
import { changeTheme } from './helpers/changeTheme';

import AppRoutes from './config/AppRoutes/AppRoutes';
import { countryData } from './helpers/countryValues';
import { IdleTracker } from './components/idle-tracker/idle-tracker';
import moment from 'moment';
import { addLocale } from 'primereact/api';
import { ar } from './config/calendar';

function App() {
  const { i18n } = useTranslation();
  const baseRoute = `/${i18n.language}`;

  addLocale('ar', ar);

  moment.locale(i18n.language === 'ar' ? 'ar-ly' : i18n.language);

  initiateServiceInstance({
    API_URL: constants.API_URL,
    ONBOARDING_GRAVITEE_KEY: constants.ONBOARDING_GRAVITEE_KEY,
  });

  // SME Configuration
  initiateSmeInstance({
    SME_URL: constants.SME_URL,
    SME_GRAVITEE_KEY: constants.SME_GRAVITEE_KEY,
  });

  //Certification Configuration
  initiateCertificationInstance({
    API_URL: constants.API_URL,
    CERTIFICATION_GRAVITEE_KEY: constants.CERTIFICATION_GRAVITEE_KEY,
  });

  // Print Configuration
  initiatePrintInstance({ PRINT_URL: constants.PRINT_URL });

  // Statistics Configuration
  initiateStatisticsInstance({
    STATISTICS_API_URL: constants.STATISTICS_API_URL,
    STATISTICS_GRAVITEE_KEY: constants.STATISTICS_GRAVITEE_KEY,
  });

  // OTP Configuration
  initiateOTPInstance({
    OTP_URL: constants.OTP_URL,
    OTP_GRAVITEE_KEY: constants.OTP_GRAVITEE_KEY,
  });

  //Onboarding Configuration
  initiateOnboardingInstance({
    ONBOARDING_URL: constants.ONBOARDING_URL,
    ONBOARDING_GRAVITEE_KEY: constants.ONBOARDING_GRAVITEE_KEY,
  });

  //Onboarding Authorization Configuration
  initiateOnboardingAuthInstance({
    ONBOARDING_URL: constants.ONBOARDING_URL,
    ONBOARDING_GRAVITEE_KEY: constants.ONBOARDING_AUTH_GRAVITEE_KEY,
  });

  //OIDC Configuration
  initiateAuthInstance({
    API_URL: constants.AUTH_URL,
    OIDC_GRAVITEE_KEY: constants.AUTH_URL_TOKEN,
  });

  changeTheme(constants.THEMES[constants.ENVIRONEMNT] || constants.THEMES.eiv);

  useEffect(() => {
    document.title = constants.ENVIRONEMNT;
  }, []);

  const country = window?._env_?.REACT_APP_COUNTRY || 'BH';

  return (
    <BrowserRouter>
      <AuthenticationProvider>
        <Provider>
          <IdleTracker />
          <AppRoutes
            TAX_COUNTRY={constants.TAX_COUNTRY}
            baseRoute={baseRoute}
            countryData={countryData[country]}
          />
          <ToastContainer hideProgressBar newestOnTop={false} closeOnClick />
        </Provider>
      </AuthenticationProvider>
    </BrowserRouter>
  );
}

export default React.memo(App);
